import { application } from "./application";

import TomSelectController from "./tom_select_controller";
application.register("tom-select", TomSelectController);

export { application }